module.exports = __webpack_public_path__ + "static/media/Maven_6241.49f577f1.jpg";